import React, { useEffect, useState } from 'react';
import cn from 'classnames';
import {
  CUSTOM_MESSAGES, LABEL,
} from '../../veriables';
import Styles from './multipleSelectedCart.module.scss';

const RenderCount = ({
  item,
  changeItemQuantity,
}) => {
  const [count, setCount] = useState(item?.quantity);
  useEffect(() => {
    if (item?.quantity) {
      setCount(item?.quantity);
    }
  }, [item]);
  return (
    <div className="col-12 p-0 fs-14 row mx-0 align-items-center justify-content-between">
      <button
        className={cn(Styles.incDecButton, 'btn-secondary od-dec-font-btn-color od-dec-counter-btn-color')}
        type="button"
        onClick={() => { setCount(count - 1); changeItemQuantity(count - 1, item); }}
        disabled={count < 1}
        aria-label="minusCartQtyBtn"
      >
        <i className="fas fa-minus" aria-hidden="true" />
      </button>
      <div className="text-primary od-text-primary">{count}</div>
      <button
        className={cn(Styles.incDecButton, 'btn-secondary od-inc-counter-btn-color od-inc-font-btn-color')}
        type="button"
        onClick={() => { setCount(count + 1); changeItemQuantity(count + 1, item); }}
        aria-label="plusCartQtyBtn"
      >
        <i className="fas fa-plus" aria-hidden="true" />
      </button>
    </div>
  );
};

const MultipleSelectedCartComponent = ({
  cartItems,
  renderModifier,
  currencySymbol,
  handleEdit,
  subTotalAmount,
  buttonList,
  handleButtonClick,
  changeItemQuantity,
  menuItemsHashTable,
}) => {
  const isPackItem = (item) => {
    return menuItemsHashTable?.[item?.menuItemId]?.minOrderQuantity > 0 || menuItemsHashTable?.[item?.menuItemId]?.cardType === 1;
  };
  return (
    <div className="col-12 h-100 p-0">
      <div className="h-5 w-100 fs-18 fw-600 od-text-primary text-center text-primary">
        {LABEL().CART}
      </div>
      <div className="h-85 overflowY">
        {cartItems?.length > 0 ? cartItems?.map((item) => {
          return (
            <div key={item.internalId} className={cn('od-text-primary text-primary col-12 my-1 p-1 rounded', item.isLinked ? 'd-none' : '', item?.isProcessing ? `od-check-unsent-background ${Styles.processingItem}` : 'background-secondary od-container-card-background')}>
              <div className="col-12 h-100 px-0 fs-16 row mx-0">
                {/* <span className={cn('p-0 fs-16', item.quantity > 1 || tableData.splitValue > 1 ? 'col-1' : '')}>
                  {`${(item.quantity > 1 || tableData.splitValue > 1) ? `${item.quantity}${tableData.splitValue > 1 ? `/${tableData.splitValue} ` : ''}x ` : ''}`}
                </span> */}
                <div className={cn('p-0 col-11')}>
                  {item.menuItemName}
                </div>
                <div
                  role="presentation"
                  onClick={() => { if (!isPackItem(item)) handleEdit(item); }}
                  className={cn('col-1 p-0 fs-14 text-right', isPackItem(item) ? 'od-text-secondary text-secondary' : 'od-text-primary text-primary')}
                  style={{ cursor: isPackItem(item) ? 'not-allowed' : 'pointer', color: isPackItem(item) ? 'rgb(177,177,177)' : undefined }}
                >
                  <i className="fa fa-edit" aria-hidden="true" />
                </div>
              </div>
              <div className="col-12 p-0">
                {item.modifiers && renderModifier(item.modifiers)}
                <div className="text-left pl-2 fs-16">
                  {`${item.note ? `- ${item.note}` : ''}`}
                </div>
              </div>
              <div className="col-12 p-0 row mx-0 py-1 fs-16">
                <div className="col-6 p-0">
                  <RenderCount
                    item={item}
                    changeItemQuantity={changeItemQuantity}
                  />
                </div>
                <div className="col-6 p-0 text-right">
                  {currencySymbol}{(item.price).toFixed(2)}
                </div>
              </div>
            </div>
          );
        }) : <div className="px-2 h-95 od-text-primary  border-color-primary row mx-0 fs-600 justify-content-center align-items-center fs-20">{CUSTOM_MESSAGES().NO_ITEM_FOUND}</div>}
      </div>
      <div className="h-5 w-100 row mx-0">
        {cartItems && cartItems.length > 0 && buttonList.map((btn) => {
          return btn.isShow && (
            <div key={btn.key} className={cn('col-6 px-1 rounded')}>
              <button
                type="button"
                className={cn('w-100 fs-14 btn-primary btn-ripple rounded btn20 btn od-btn-primary fw-600')}
                onClick={() => handleButtonClick(btn.key, cartItems)}
              >
                <span className="px-2">
                  {btn.displayName}
                </span>
              </button>
            </div>
          );
        })}
      </div>
      <div className="col-12 row mx-0 px-1 h-5 od-text-primary text-primary p-1 background-secondary od-container-card-background rounded fs-14">
        <div className="col-6 p-0 text-left">{LABEL().SUB_TOTAL}:</div>
        <div className="col-6 p-0 text-right">{LABEL().CURRENCY_SYMBOL}{subTotalAmount.toFixed(2)}</div>
      </div>
    </div>
  );
};

export default MultipleSelectedCartComponent;
